<template>
  <div id="chart">
    <apexchart type="donut" width="350" :options="chartOptions" :series="series" />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts"
import { getGroupsTen, getJobsDesc } from "../databaseRequests"
import { mixPalette } from "../generalFunctions"

var jobsData = getGroupsTen()
var jobsLabels = getJobsDesc()

export default {
  name: "PieJobs",
  components: {
    apexchart: VueApexCharts
  },
  data: function() {
    return {
      series: jobsData,
      labels: jobsLabels,
      chartOptions: {
        labels: jobsLabels,
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: "bottom"
              }
            }
          }
        ],
        colors: mixPalette
      }
    }
  }
}
</script>

<style scoped></style>
